import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

import App from './app';

ReactDOM
    .createRoot(document.getElementById('root') as HTMLElement)
    .render(
        <div className="app">
            <React.StrictMode>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </React.StrictMode>
        </div>
    );
